(() => {
  function upsellPDP() {
    const parent = document.querySelector('product-info')
    const addtocartButton = parent.querySelector('[js-product-atc-button]')
    const complementaryCheckbox = parent.querySelector('[js-complementary-product]');
    let upsellProductPrice = 0;
    let upsellProductComparePrice = 0;
    let hbCurrentVariantPrice = 0;
    let hbCurrentVariantCompareAtPrice = 0;
    let hbMainProductDiscount = 0;
    let hbComplementaryProductPrice = 0;
    let hbComplementaryProductCompareAtPrice = 0;


    function getMainProductPrice() {
      const mainProductPrice = JSON.parse(document.querySelector('[js-main-product-data]').innerHTML)
      hbCurrentVariantPrice = parseFloat(mainProductPrice.hbCurrentVariantPrice);
      hbCurrentVariantCompareAtPrice = parseFloat(mainProductPrice.hbCurrentVariantCompareAtPrice);
      hbMainProductDiscount = parseFloat(mainProductPrice.hbMainProductDiscount);
    }

    function getUpsellProductPrice() {
      const upsellProductPrice = JSON.parse(document.querySelector('[js-upsell-product-data]').innerHTML)
      hbComplementaryProductPrice = parseFloat(upsellProductPrice.hbComplementaryProductPrice);
      hbComplementaryProductCompareAtPrice = parseFloat(upsellProductPrice.hbComplementaryProductCompareAtPrice);
    }

    getMainProductPrice();
    getUpsellProductPrice();

    if (complementaryCheckbox) {
      complementaryCheckbox.addEventListener('change', (event) => updateComplementaryProduct(complementaryCheckbox, hbCurrentVariantPrice, hbCurrentVariantCompareAtPrice, changeVariant = false));
    }

    document.addEventListener('onvariant:change', ({ detail: { currentVariant }}) => {
      if (complementaryCheckbox) {
        updateComplementaryProduct(complementaryCheckbox, currentVariant.price, currentVariant.compare_at_price, changeVariant = true)
      }
    })

    function updateComplementaryProduct(target, currentVariantPrice, currentVariantComparePrice) {

        if(changeVariant) {
          if(hbMainProductDiscount) {
            const dicountPrice = parseFloat(hbMainProductDiscount) / 100 * currentVariantPrice;
            hbCurrentVariantPrice = currentVariantPrice - dicountPrice;
            hbCurrentVariantCompareAtPrice = currentVariantPrice;
          } else {
            hbCurrentVariantPrice = currentVariantPrice;
            hbCurrentVariantCompareAtPrice = currentVariantComparePrice;
          }
        }
       
        if (target.checked) {
          upsellProductPrice = hbComplementaryProductPrice;
          upsellProductComparePrice = hbComplementaryProductCompareAtPrice;
        } else {
          upsellProductPrice = 0;
          upsellProductComparePrice = 0;
        }

        const totalPrice = upsellProductPrice + hbCurrentVariantPrice; 
        const totalComparePrice = upsellProductComparePrice + hbCurrentVariantCompareAtPrice;

        if (addtocartButton) {
          const totalSalePrice = addtocartButton.querySelectorAll('[js-price-item--sale]')
          const compareAtPriceTags = addtocartButton.querySelectorAll('[js-price-item--compare-price]');
          totalSalePrice.forEach(salePrice=>{
            salePrice.innerHTML = `$${(totalPrice / 100).toFixed(2).toString().replace('.00', '')}`
          })
          compareAtPriceTags.forEach(compareAtPriceTag=>{
            compareAtPriceTag.innerHTML = `$${(totalComparePrice / 100).toFixed(2).toString().replace('.00', '')}`
          })
        }
    } 
  }

  upsellPDP();

  document.addEventListener('upsellPDP:init', upsellPDP)

})()